import HeaderPage from 'components/HeaderPage/HeaderPage';
import { useState, useEffect } from 'react';
import LogoSIMAC from 'assets/images/Logo_SIMAC.svg';
import { ReactComponent as Question } from 'assets/images/GuiasUsuarios/Centro_ayuda_que_es.svg';
import { Button, Spin, Row, Col, Divider } from 'antd';
import { getCentroAyudaData } from 'actions/centroAyuda.actions';
import { logoAssigner, nameAssigner } from 'utils/logoAssigner/logoAssigner';
import ButtonCard from './components/ButtonCard/ButtonCard';
import ModalInfoSIMAC from './components/ModalInfoSIMAC/ModalInfoSIMAC';
import ContenedorGuias from './components/ContenedorGuias/ContenedorGuias';
import './CentroAyuda.scss';

export const CentroAyuda = () => {
  const [loading, setLoading] = useState(true);
  const [helpCenterData, setHelpCenterData] = useState(null);
  const [logo, setLogo] = useState(LogoSIMAC);
  const [textLogo, setTextLogo] = useState(null);
  const [guiadesDocuments, setGuiadesDocument] = useState([]);
  const [modalInfoOpen, setModalInfoOpen] = useState(false);

  const gutterFix = [
    { xs: 8, sm: 8, md: 8, lg: 16 },
    { xs: 8, sm: 8, md: 8, lg: 32 }
  ];

  useEffect(() => {
    const fetchCenterHelpData = async () => {
      try {
        // Inicia la petición al montar el componente en el DOM
        const { success, helpCtrData } = await getCentroAyudaData();
        if (success) {
          setHelpCenterData(helpCtrData);
        }
      } catch (error) {
        console.log('Error en la petición del servicio de Centro de ayuda', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCenterHelpData();
  }, []);

  const handleScreen = (idDocumentTypes, screenType, textScreen) => {
    setLogo(screenType);
    setTextLogo(textScreen);
    const tipoGuia = helpCenterData.data.centroAyuda.find((e) => e.idTipoGuia === idDocumentTypes);
    setGuiadesDocument(tipoGuia.documentos);
  };

  const titleHelpCenter = (
    <div>
      Consulta las diferentes guías de usuario de SIMAC web y SIMAC móvil.
      <br />
      Busca un tema, selecciona una guía, descarga y consulta.
    </div>
  );

  const openModalInfo = () => {
    setModalInfoOpen(true);
  };

  const onCloseModalInfo = () => {
    setModalInfoOpen(false);
  };

  const renderGuias = () => {
    let centroAyuda = [];
    if (helpCenterData != null) {
      const { data } = helpCenterData;
      centroAyuda = data.centroAyuda.sort((a, b) => a.idTipoGuia - b.idTipoGuia);
      // console.log('centroAyuda', centroAyuda);
    }
    return centroAyuda.map((guia) => (
      <Row gutter={gutterFix} key={guia.value} className="cards-guias">
        <Col span={12}>
          <ButtonCard
            idGuideType={guia.idTipoGuia}
            guiadeType={nameAssigner(guia.idTipoGuia)}
            guiadeLogo={logoAssigner(guia.img_64)}
            handleScreen={handleScreen}
          />
        </Col>
      </Row>
    ));
  };

  return (
    <div className="guias-section-container">
      <div className="seccion-header-centro-ayuda">
        <div className="header-page-centro-ayuda">
          <HeaderPage section2="Centro de ayuda" title="Centro de ayuda" header={titleHelpCenter} />
        </div>
        <div className="btn-modal">
          <Button
            type="none"
            onClick={openModalInfo}
            icon={<Question style={{ width: '60px' }} />}
          />
        </div>
        <ModalInfoSIMAC open={modalInfoOpen} onCancel={onCloseModalInfo} />
        {loading && (
          <Row align="middle" justify="center">
            <Spin size="large" />
          </Row>
        )}
      </div>
      {/* División del contenido del centro de ayuda */}
      <Divider style={{ marginTop: '-15px' }} />
      <Row gutter={gutterFix}>
        <div className="guias-container">
          <Row gutter={gutterFix} className="guiades-cards-container">
            {renderGuias()}
          </Row>
          <Row className="guiades-screen-container">
            {!loading && (
              <ContenedorGuias
                logo={logo}
                textLogo={textLogo}
                guiadesDocuments={guiadesDocuments}
              />
            )}
          </Row>
        </div>
      </Row>
    </div>
  );
};
